import {IconButton, ITextFieldProps, Label, Separator, SharedColors, Stack, TextField,} from "@fluentui/react";
import {useBoolean} from "@fluentui/react-hooks";
import React, {FC, useEffect} from "react";
import {useTranslation} from "react-i18next";
import {useErrorMessage} from "../hooks/useErrorMessage";

interface IMultilineTextComponent extends ITextFieldProps {
    showEditModeToggle?: boolean;
}

export const MultilineTextComponent: FC<IMultilineTextComponent> = (props) => {
    const {t} = useTranslation();
    const [editMode, {setTrue: enterEditMode, setFalse: exitEditMode}] =
        useBoolean(true);
    const {localErrorMessage, clearLocalErrorMessage} = useErrorMessage(
        props.errorMessage,
    );

    useEffect(() => {
        if (!props.showEditModeToggle) {
            enterEditMode();
        } else {
            exitEditMode();
        }
    }, [props.showEditModeToggle]);

    if (editMode && !props.showEditModeToggle) {
        return <TextField {...props} />;
    } else if (editMode && props.showEditModeToggle) {
        return (
            <Stack horizontalAlign="stretch" verticalAlign="start">
                <Stack horizontal horizontalAlign="space-between">
                    <Label>{props.label}</Label>
                    <IconButton
                        iconProps={{iconName: "Cancel"}}
                        style={{color: SharedColors.red10}}
                        onClick={exitEditMode}
                    />
                </Stack>
                <TextField
                    {...props}
                    label={undefined}
                    autoFocus={true}
                    errorMessage={localErrorMessage}
                    onFocus={(e) => {
                        clearLocalErrorMessage();
                        props.onFocus?.(e);
                    }}
                />
            </Stack>
        );
    } else {
        return (
            <Stack
                horizontalAlign="stretch"
                verticalAlign="start"
                onDoubleClick={enterEditMode}
            >
                <Stack horizontal horizontalAlign="space-between">
                    <Label>{props.label}</Label>
                    <IconButton
                        iconProps={{iconName: "Edit"}}
                        onClick={enterEditMode}
                    />
                </Stack>
                <p
                    style={{
                        whiteSpace: "pre-line",
                    }}
                >
                    {props.value}
                </p>
                <Separator/>
            </Stack>
        );
    }
};
